import { Link } from 'react-router-dom';
import { categories } from '@/mocks/kunlun-data';

const categoryImages: Record<string, string> = {
  'glacier-source': 'https://readdy.ai/api/search-image?query=A%20luxurious%20glass%20bottle%20of%20premium%20mineral%20water%20on%20a%20clean%20white%20minimalist%20background%20with%20soft%20diffused%20lighting%2C%20elegant%20product%20photography%2C%20crystal%20clear%20water%20visible%20through%20the%20bottle%2C%20subtle%20ice-like%20textures%2C%20sophisticated%20and%20refined%20composition%2C%20premium%20brand%20aesthetic&width=600&height=400&seq=cat-glacier-01&orientation=landscape',
  'snow-spring': 'https://readdy.ai/api/search-image?query=A%20crystal%20clear%20bottle%20of%20pure%20spring%20water%20standing%20on%20a%20smooth%20river%20stone%20with%20soft%20morning%20sunlight%20filtering%20through%2C%20natural%20organic%20composition%2C%20fresh%20and%20clean%20minimalist%20product%20photography%2C%20dew%20drops%20on%20the%20bottle%20surface&width=600&height=400&seq=cat-spring-01&orientation=landscape',
  'limited-edition': 'https://readdy.ai/api/search-image?query=A%20luxurious%20handcrafted%20crystal%20glass%20water%20bottle%20with%20gold%20foil%20accents%20on%20a%20dark%20elegant%20marble%20surface%20with%20dramatic%20lighting%2C%20exclusive%20limited%20edition%20product%20photography%2C%20opulent%20and%20sophisticated%20aesthetic%2C%20collectors%20item%20feel&width=600&height=400&seq=cat-limited-01&orientation=landscape',
};

export default function ProductSeries() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600 uppercase font-heading">
            PRODUCT SERIES
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
            产品系列
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            三大产品系列，满足不同消费场景与品质需求，让每一位消费者都能找到适合自己的纯净选择
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-product-shop>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/categories/${cat.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative h-52 md:h-60 overflow-hidden">
                <img
                  src={categoryImages[cat.slug]}
                  alt={`昆仑雪${cat.name}`}
                  title={`昆仑雪${cat.name} - ${cat.subtitle}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mb-3">{cat.subtitle}</p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  查看详情
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}